import React, { useState, useEffect, Fragment, ReactDOM } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import Edit from "./Edit";
import GetParsedDate from "../../shared/GetParsedDate";
import ErrorModal from "../../ErrorModal";
//const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  mekhraz_id,
  //setUpdateMekhraz,
  // updateMekhraz,
}) => {
  const [extentions, setExtentions] = useState(null);
  const [extId, setExtId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          "/jobs/extention?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        isMounted &&
          setExtentions(
            response.data.sort((a, b) => {
              return b.id - a.id;
            })
          );
      } catch (err) {
        console.error(err);
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);
  const handleEditClick = (event, Ext) => {
    event.preventDefault();
    setExtId(Ext.id);
  };
  const handleCancelClick = () => {
    setExtId(null);
  };

  if (!extentions) return null;
  return (
    <>
      <div>
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form onSubmit={increment}>
              <Table hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>משתמש</th>
                    <th>זמן ביצוע הפעולה</th>
                    <th>תאריך קודם</th>
                    <th>תאריך חדש</th>
                    <th>הערות</th>
                  </tr>
                </thead>
                <tbody>
                  {extentions?.map((ext) => (
                    <Fragment key={ext.id}>
                      {extId === ext.id ? (
                        <Edit
                          ext={ext}
                          handleCancelClick={handleCancelClick}
                          increment={increment}
                          counter={counter}
                          setExtId={setExtId}
                          //setUpdateMekhraz={setUpdateMekhraz}
                          //updateMekhraz={updateMekhraz}
                        />
                      ) : (
                        <ReadOnlyRows
                          ext={ext}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          setExtId={setExtId}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>

      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  ext,
  handleEditClick,
  setExtId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  return (
    <>
      <tr>
        <td>{ext.id}</td>
        <td>{ext.created_by_user}</td>
        <td>
          <GetParsedDate strDate={ext.log_created_at} withTime={false} />{" "}
        </td>
        <td>{ext.previous_date}</td>
        <td>{ext.ext_date}</td>
        <td className="td-max-width">{ext.notes}</td>
      </tr>
    </>
  );
};
